// File: cgp-api.ts
// Author: Joseph M Diaz
// Date: 5/12/2017
// Desc: Api class that handles common code during ajax requests.
// Other Contributors:

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { cgpAuthentication } from './cgp-authentication';

@Injectable()
export class CgpApiService {
    constructor(private http: HttpClient) { }

    beforeSend(opts) {
        // do common stuff here such as adding the cgp token to each request
        //

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        const localToken = cgpAuthentication.getAuthToken();

        if (!localToken || localToken.length === 0) {
            window.location.replace('#/logged-out');
            return {
                opts: null,
                error: 'Auth token is not valid.'
            };
        } else {
            headers = headers.set('Authorization', localToken);
        }

        return {
            opts: {
                ...opts,
                headers
            },
            error: null
        };
    }

    private beforeError() {
        // do common stuff here
        //
    }

    private beforeComplete() {
        // do common stuff here
        //
    }

    get(url, opts) {
        const self = this;
        const beforeSendResult = self.beforeSend(opts);

        url = encodeURI(url);
        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                self.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                self.http.get(url, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            self.beforeError();
                            observer.error(error);
                        },
                        () => {
                            self.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    post(url, body, opts) {
        const self = this;
        const beforeSendResult = self.beforeSend(opts);

        url = encodeURI(url);
        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                self.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                self.http.post(url, body, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            self.beforeError();
                            observer.error(error);
                        },
                        () => {
                            self.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    public multipartPost(url, body, opts) {
        const self = this;
        const beforeSendResult = self.beforeSend(opts);

        url = encodeURI(url);
        opts = beforeSendResult.opts;
        opts.headers = opts.headers.delete('Content-Type');
        opts.headers = opts.headers.set('Accept', 'application/json');

        return (beforeSendResult.error)
            ? new Observable(observer => {
                self.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                self.http.post(url, body, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            self.beforeError();
                            observer.error(error);
                        },
                        () => {
                            self.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    put(url, body, opts) {
        const self = this;
        const beforeSendResult = self.beforeSend(opts);

        url = encodeURI(url);
        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                self.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                self.http.put(url, body, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            self.beforeError();
                            observer.error(error);
                        },
                        () => {
                            self.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    delete(url, opts) {
        const self = this;
        const beforeSendResult = self.beforeSend(opts);

        url = encodeURI(url);
        opts = beforeSendResult.opts;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                self.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                self.http.delete(url, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            self.beforeError();
                            observer.error(error);
                        },
                        () => {
                            self.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }

    deleteWithBody(url, opts, body) {
        const self = this;
        const beforeSendResult = self.beforeSend(opts);

        url = encodeURI(url);
        opts = beforeSendResult.opts;
        opts['body'] = body;

        return (beforeSendResult.error)
            ? new Observable(observer => {
                self.beforeError();
                observer.error(beforeSendResult.error);
            })
            : new Observable(observer => {
                self.http.delete(url, opts)
                    .subscribe(
                        value => observer.next(value),
                        error => {
                            self.beforeError();
                            observer.error(error);
                        },
                        () => {
                            self.beforeComplete();
                            observer.complete();
                        }
                    );
            });
    }
}